export function camelCase(text: string): string {
    let result = text
        .replace(/_+/gi, ' ')
        .replace(/\w+\s*/g, (word: string) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
        .replace(/(\s|_)+/gi, '');
    result = result.charAt(0).toLowerCase() + result.substr(1);
    return result;
}
